import { ApplicationRef, NgZone } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { bootstrapApplication, createApplication } from '@angular/platform-browser';
import { prepareApp } from '@mocks';
import { App } from './app/app';
import { AppRoot } from './app/app-root';
import { appConfig } from './app/app.config';
import { ApplePayComponent } from './app/pages/public/ecom/applepay/component';
import { GooglePayComponent } from './app/pages/public/ecom/googlepay/component';
import { EcomCashoutSetecomComponent } from './app/pages/public/ecomcashout/setecom/component';

prepareApp().then(async () => {
  if (document.querySelector('app-root')) {
    await bootstrapApplication(AppRoot, appConfig);
  }

  //if (environment.devProfile !== EDeveloperProfile.IANTROPOV_IIS) {
  const appref: ApplicationRef = await createApplication(appConfig);
  const injector = appref.injector;

  const ngZone = injector.get(NgZone);
  ngZone.run(() => {
    // if (window) {
    //   if (!environment.console.log) {
    //     window.console.log = () => {};
    //   }
    //   if (!environment.console.debug) {
    //     window.console.debug = () => {};
    //   }
    // }

    console.log('Angular Elements запущен');
  });

  const appElement = createCustomElement(App, { injector });
  customElements.define('app-spa-paynet-wallet', appElement);

  const ecomCashoutSetEcomElement = createCustomElement(
    EcomCashoutSetecomComponent,
    { injector },
  );
  customElements.define(
    'app-paynet-ecomcashout-setecom',
    ecomCashoutSetEcomElement,
  );

  const googlePayElement = createCustomElement(GooglePayComponent, {
    injector,
  });
  customElements.define('app-paynet-googlepay', googlePayElement);

  const applePayElement = createCustomElement(ApplePayComponent, {
    injector,
  });
  customElements.define('app-paynet-applepay', applePayElement);
  //}
  /****************************************************************************/
  /* если элементов больше одного на родительской странице, и чтобы они не дрались за общий рутинг,
   сделаем 2 варианта */
  const appref2: ApplicationRef = await createApplication(appConfig);
  const injector2 = appref2.injector;

  const ngZone2 = injector2.get(NgZone);
  ngZone2.run(() => {
    // if (window) {
    //   if (!environment.console.log) {
    //     window.console.log = () => {};
    //   }
    //   if (!environment.console.debug) {
    //     window.console.debug = () => {};
    //   }
    // }

    console.log('Angular Elements 2 запущен');
  });

  const appElement2 = createCustomElement(App, { injector: injector2 });
  customElements.define('app-spa-paynet-wallet2', appElement2);
});
